<script>
import {neoparentPatients} from "@/api";

export default {
  name: "neoparent-readmit",
  methods: {
    async readmit() {
      await neoparentPatients.readmitPatient(this.$store.getters.nurse.patient.id);
      window.location.reload();
    }
  },
}
</script>

<template>
  <v-container fluid>
    <div style="{
      border-bottom: 3px solid #afdfd3
      }">
      {{$t('dash.patient.not-admitted')}}
      <Button
        style="{
          margin-left: 10px
        }"
        v-ripple="'rgba(255, 255, 255, 0.35)'"
        shadow="true"
        :title="$t('dash.patient.resubmit')"
        color="#FFFFFF"
        bgcolor="#F44336"
        @click.native="readmit()"
        width="50%"></Button>
    </div>
  </v-container>
</template>

<style scoped lang="scss">

</style>
